import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_RED } from '../../../assets/styles/colors';
import { SmallText } from '../../typography';

export default styled.div`
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }

  .loan-summary-wrap {
    margin-top: 48px;
    padding: 24px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;

    .divider {
      width: 100%;
      height: 1px;
      background: rgba(47, 46, 65, 0.2);
    }

    &--top {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 16px;
      text-align: center;
    }
    &--bottom {
      padding-top: 30px;
      display: flex;
      flex-direction: column;
      &__row {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:last-child {
          padding-bottom: 5px;
        }
      }
    }
  }

  .submit-wrap {
    margin-top: 38px;
    button {
      width: 100%;
    }

    .two-buttons {
      display: flex;
      gap: 20px;

      button {
        font-size: 16px;
        padding: 16px 8px;
        text-transform: none;

        &.secondary {
          font-weight: normal;
        }
      }
    }
  }

  .checkbox-wrap {
    padding-top: 24px;
    .hint {
      padding-top: 15px;
    }
  }
`;

export const ErrorWrapSC = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${rgba(COLOR_RED, 0.1)};
  p {
    &:last-child {
      line-height: 1.25;
    }
  }
`;

export const ErrorText = styled(SmallText)`
  padding: 6px 0;
  color: ${COLOR_RED};
`;
